import { render, staticRenderFns } from "./baseImg.vue?vue&type=template&id=42ff2d47&scoped=true&"
import script from "./baseImg.vue?vue&type=script&lang=js&"
export * from "./baseImg.vue?vue&type=script&lang=js&"
import style0 from "./baseImg.vue?vue&type=style&index=0&id=42ff2d47&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff2d47",
  null
  
)

export default component.exports